export default __webpack_public_path__ + "static/media/file_icon.615b9414.PNG";